module.exports = __webpack_public_path__ + "static/coindesk-article-screenshot-77992ab130042eec78fd8767bb3e2a51.webp";